import { IMailDataV1 } from '../tools/api.service';
import { Injectable } from "@angular/core";

@Injectable()
export class Maildata {
  activationid: number;
  activStatut: number;
  scalecode: string;
  usermail: string;
  userlanguage: string;
  userfirstname: string;
  username: string;
  userloginunisite: string;
  userpwdunisite: string;
  usercompany: string;
  payormail: string;
  payorlanguage: string;
  payorfirstname: string;
  payorname: string;
  payorloginunisite: string;
  payorpwdunisite: string;
  payorcompany: string;
  ctcmail: string;
  ctclanguage: string;
  ctcfirstname: string;
  ctcname: string;

  public static parseToMaildata(item: Maildata): IMailDataV1 {
    let result = new IMailDataV1();
    result.activationId = item.activationid;
    result.activStatut = item.activStatut;
    result.scaleCode = item.scalecode;
    result.userMail = item.usermail;
    result.userLanguage = item.userlanguage;
    result.userFirstname = item.userfirstname;
    result.userName = item.username;
    result.userLoginUnisite = item.userloginunisite;
    result.userPwdUnisite = item.userpwdunisite;
    result.userCompany = item.usercompany;
    result.payorMail = item.payormail;
    result.payorLanguage = item.payorlanguage;
    result.payorFirstname = item.payorfirstname;
    result.payorName = item.payorname;
    result.payorLoginUnisite = item.payorloginunisite;
    result.payorPwdUnisite = item.payorpwdunisite;
    result.payorCompany = item.payorcompany;
    result.ctcMail = item.ctcmail;
    result.ctcLanguage = item.ctclanguage;
    result.ctcFirstname = item.ctcfirstname;
    result.ctcName = item.ctcname;

    return result;
  }
}
